import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "open-cooperation-child" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "form-style"
}
const _hoisted_4 = { class: "form-content" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "form-style"
}
const _hoisted_7 = { class: "form-content" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "form-style"
}
const _hoisted_10 = { class: "form-content" }

import { ref, reactive, watch, onMounted } from 'vue'
import type { FormInstance, FormRules, UploadUserFile } from 'element-plus'
import { addConsult } from '@/api'
import { ElMessage } from "element-plus";
import { asynchronousRetrieval } from '@/utils'
interface RuleForm {
  name: string
  companyName: string
  phone: string
  message: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'OpenCooperation',
  setup(__props) {

const loadUrl: any = ref({})

const showIndex = ref(-1)
let timer: any = null;
let upDataTime = ref(0)

const ruleFormRef1 = ref<FormInstance>()
const ruleFormRef2 = ref<FormInstance>()
const ruleFormRef3 = ref<FormInstance>()

const ruleForm: any = reactive<RuleForm>({
  name: '',
  companyName: '',
  phone: '',
  message: '',
})

const rules = reactive<FormRules<RuleForm>>({
  name: [
    { required: true, message: '请输入姓名', trigger: 'blur' }
  ],
  companyName: [
    { required: true, message: '请输入公司名', trigger: 'blur', }
  ],
  phone: [{ required: true, message: '请输入电话号码', trigger: 'blur', }],
})

const showForm = (index: number) => {
  const time = new Date().getTime()
  if (time - upDataTime.value < 10) return
  clearTimeout(timer)
  showIndex.value = index
}

const submitForm = async (formEl: FormInstance | undefined, type: number) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      addConsult({ ...ruleForm, consultType: type, appId: 1 }).then((res) => {
        ElMessage({
          message: '感谢您的反馈!',
          type: "success",
          duration: 2000,
        })
        ruleForm.name = ''
        ruleForm.companyName = ''
        ruleForm.phone = ''
        ruleForm.message = ''
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}

onMounted(async() => {
  const shuzhi: any = await asynchronousRetrieval('nfznxr-images/shuzhi.png');
  const zhongduan: any = await asynchronousRetrieval('nfznxr-images/zhongduan.png');
  const Bduan: any = await asynchronousRetrieval('nfznxr-images/Bduan.png');
  loadUrl.value = { shuzhi, zhongduan, Bduan }
})

watch(showIndex, (newState) => {
  if (newState == -1) {
    upDataTime.value = new Date().getTime()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "shuzhi-form",
      onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (showForm(1)))
    }, [
      _createElementVNode("img", {
        src: loadUrl.value.shuzhi
      }, null, 8, _hoisted_2),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text" }, "我是数智产品品牌方", -1)),
      (showIndex.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "title" }, "品牌方合作咨询", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form, {
                ref_key: "ruleFormRef1",
                ref: ruleFormRef1,
                model: ruleForm,
                rules: rules,
                "require-asterisk-position": "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "姓名",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.name) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "公司名称",
                    prop: "companyName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.companyName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.companyName) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "电话",
                    prop: "phone"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.phone,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.phone) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "留言",
                    prop: "message"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        type: "textarea",
                        modelValue: ruleForm.message,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.message) = $event)),
                        placeholder: "请输入",
                        resize: "none"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { class: "form-submit" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "btn-primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef1.value, 1)))
                      }, " 提交 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _createElementVNode("div", {
              class: "close-icon",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (showIndex.value = -1))
            })
          ]))
        : _createCommentVNode("", true)
    ], 32),
    _createElementVNode("div", {
      class: "shuzhi-form",
      onMouseenter: _cache[13] || (_cache[13] = ($event: any) => (showForm(2)))
    }, [
      _createElementVNode("img", {
        src: loadUrl.value.zhongduan
      }, null, 8, _hoisted_5),
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text" }, "我是渠道端/零售终端", -1)),
      (showIndex.value == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "title" }, "渠道端/零售终端合作咨询", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form, {
                ref_key: "ruleFormRef2",
                ref: ruleFormRef2,
                model: ruleForm,
                rules: rules,
                "require-asterisk-position": "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "姓名",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.name,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ruleForm.name) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "公司名称",
                    prop: "companyName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.companyName,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ruleForm.companyName) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "电话",
                    prop: "phone"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.phone,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ruleForm.phone) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "留言",
                    prop: "message"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        type: "textarea",
                        modelValue: ruleForm.message,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ruleForm.message) = $event)),
                        placeholder: "请输入",
                        resize: "none"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { class: "form-submit" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "btn-primary",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (submitForm(ruleFormRef2.value, 2)))
                      }, " 提交 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _createElementVNode("div", {
              class: "close-icon",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (showIndex.value = -1))
            })
          ]))
        : _createCommentVNode("", true)
    ], 32),
    _createElementVNode("div", {
      class: "shuzhi-form",
      onMouseenter: _cache[20] || (_cache[20] = ($event: any) => (showForm(3)))
    }, [
      _createElementVNode("img", {
        src: loadUrl.value.Bduan
      }, null, 8, _hoisted_8),
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text" }, "我是B/G端需求方", -1)),
      (showIndex.value == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "title" }, "B/G端需求方合作咨询", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_form, {
                ref_key: "ruleFormRef3",
                ref: ruleFormRef3,
                model: ruleForm,
                rules: rules,
                "require-asterisk-position": "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "姓名",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.name,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((ruleForm.name) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "公司名称",
                    prop: "companyName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.companyName,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((ruleForm.companyName) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "电话",
                    prop: "phone"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        modelValue: ruleForm.phone,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((ruleForm.phone) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "留言",
                    prop: "message"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "form-input",
                        type: "textarea",
                        modelValue: ruleForm.message,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((ruleForm.message) = $event)),
                        placeholder: "请输入",
                        resize: "none"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { class: "form-submit" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "btn-primary",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (submitForm(ruleFormRef3.value, 3)))
                      }, " 提交 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _createElementVNode("div", {
              class: "close-icon",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (showIndex.value = -1))
            })
          ]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}
}

})